@if (authError) {
  <app-unauthorised-error-page></app-unauthorised-error-page>
}

@if (!authError) {
  <div class="card">
    <div class="card-header d-block py-2">
      <div class="row align-items-center justify-content-between">
        <div class="col col-auto mb-2 mb-sm-0">
          <h3 class="card-title">{{ 'admin.menu.organisations' | translate }}</h3>
        </div>
        <div class="col col-12 col-sm-auto">
          <app-search-box (searchTermProvided)="onSearchTermProvided($event)"></app-search-box>
        </div>
      </div>
    </div>
    <div class="card-body p-0 overflow-hidden">
      <app-organisation-data-grid [organisations]="organisations"
        [loading]="loading"
        [searchTerm]="searchTerm"
      ></app-organisation-data-grid>
    </div>
  </div>
}
